import classNames from "classnames";
import { ConfigContext } from "../config-provider";
import React, { useContext } from "react";
export interface IconFontProps extends React.SVGAttributes<SVGElement> {
  type?: string;
  className?: string;
  size?: React.CSSProperties["width"];
  color?: string;
  svgProps?: React.SVGAttributes<SVGSVGElement>;
  useProps?: React.SVGAttributes<SVGUseElement>;
  children?: string;
}
const IconFont: React.FC<IconFontProps> = props => {
  const { children, type = children, className, svgProps, useProps, style = {}, size, color } = props;
  let extraStyle: React.CSSProperties = {};
  if (size) extraStyle = { ...extraStyle, width: size, height: size };
  if (color) extraStyle = { ...extraStyle, fill: color };
  const { getPrefixCls } = useContext(ConfigContext);
  const prefixCls = getPrefixCls("icon-font");
  const classString = classNames('svg-icon',prefixCls, className);
  return (
    <svg
      className={classString}
      {...svgProps}
      style={{ ...extraStyle, ...style }}
      aria-hidden="true"
    >
      <use {...useProps} xlinkHref={`#${type}`}></use>
    </svg>
  );
};
export default IconFont;
